import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {Subscription} from 'rxjs';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {HelperService} from "../../service/helper.service";
import {TranslateConfigService} from "../../service/translate-config.service";

@Component({
    selector: 'app-lsp',
    templateUrl: './lsp.component.html',
    styleUrls: ['./lsp.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LspComponent implements OnInit, OnDestroy {
    @ViewChild('elWrapChar', {static: false}) elWrapChar: ElementRef;
    @ViewChild('elWrapDiceChar_1', {static: false}) elWrapDiceChar1: ElementRef;
    @ViewChild('elWrapDiceChar_2', {static: false}) elWrapDiceChar2: ElementRef;
    @ViewChild('elWrapDiceChar_3', {static: false}) elWrapDiceChar3: ElementRef;
    @ViewChild('elWrapTotal', {static: false}) elWrapTotal: ElementRef;
    @ViewChild('elWrapTotalDice', {static: false}) elWrapTotalDice: ElementRef;
    @ViewChild('lspTXCB', {static: false}) elLspTXCB: ElementRef;

    getLatest = {
        id: 0,
        result: [],
        txtResult: ''
    };
    subscriptionLSP: Subscription;
    subscriptionScreenOri: Subscription;
    isHideDice1 = false;
    isHideDice2 = false;
    isHideDice3 = false;
    isHideChartPhien = false;
    isHideTotalPhien = true;
    hChart = 86;
    wChart = 289;
    totalNumTai = 0;
    totalNumXiu = 0;
    totalDotTai = 0;
    totalDotXiu = 0;
    btnxnDisa1 = '';
    btnxnDisa2 = '';
    btnxnDisa3 = '';

    constructor(
        private modalCtr: ModalController,
        private hpService: HelperService,
        private screenOrientation: ScreenOrientation,
        public platform: Platform,
        public translateConfigService: TranslateConfigService
    ) {
        this.subscriptionLSP = this.hpService.getObserverHisPhienTXCB().subscribe(wsData => {
            const getResultLatest = wsData.slice(0, 16);
            const listHisPhien = getResultLatest.reverse();
            // START render title chart
            let rsAa=[];

            let getLatestItem = listHisPhien[listHisPhien.length - 1];
            
            if(typeof getLatestItem['result']==='string'){
                rsAa =JSON.parse(getLatestItem['result']);
            } else {
                rsAa =getLatestItem['result'];
            }
            getLatestItem['txtResult'] = (rsAa[0] + rsAa[1] + rsAa[2]) > 10 ? this.translateConfigService.getTranslateService().instant('MINI-GAME.tai') : this.translateConfigService.getTranslateService().instant('MINI-GAME.xiu');
           
            this.getLatest = getLatestItem;
            // END render title chart

            // START render chart dot number
            let htmlDotChart = '';
            const arrAnchorDot = [];
            const arrDot1 = [];
            const arrDot2 = [];
            const arrDot3 = [];
            let rsA =[];
            listHisPhien.forEach((item, idx) => {
               
                if(typeof item['result']==='string'){
                    rsA = JSON.parse(item['result']);
                } else {
                    rsA = item['result'];
                }
                
                arrDot1.push(rsA[0]);
                arrDot2.push(rsA[1]);
                arrDot3.push(rsA[2]);
                const totalDot = rsA[0] + rsA[1] + rsA[2];
                const whDot = 15;
                const wColItem = this.wChart / 15;
                const hColItem = this.hChart / 5;
                const topDot = ((18 - totalDot) / 3 ) * hColItem - whDot / 2;
                
                const leftDot = (idx * wColItem) - whDot / 2;
                arrAnchorDot.push({x: leftDot, y: topDot});
                htmlDotChart += `<span class="dotP ${totalDot > 10 ? 'dotTai' : 'dotXiu'}" style="top: ${topDot}px; left: ${leftDot}px">${totalDot}</span>`;
            });
            arrAnchorDot.forEach((item, idx) => {
                
                if (idx + 1 < arrAnchorDot.length) {
                    const nextItem = arrAnchorDot[idx + 1];
                    htmlDotChart += `<svg><line x1="${item.x + (15 / 2)}" y1="${item.y + (15 / 2)}" x2="${nextItem.x + (15 / 2)}" y2="${nextItem.y + (15 / 2)}" style="stroke:rgb(255 255 255);stroke-width:1" /></svg>`;
                }
            });
            this.elWrapChar.nativeElement.innerHTML = htmlDotChart;
            // END render chart dot number

            // START render chart dot
            this.elWrapDiceChar1.nativeElement.innerHTML = this.renderChartDot123(arrDot1, 'rgb(255 82 0)', 'dot1');
            this.elWrapDiceChar2.nativeElement.innerHTML = this.renderChartDot123(arrDot2, '#fcef54', 'dot2');
            this.elWrapDiceChar3.nativeElement.innerHTML = this.renderChartDot123(arrDot3, '#3ceefe', 'dot3');
            // END render chart dot

            // START render total num dot
            const getResultLatest75 = wsData.slice(0, 75);
            const listTotalPhien = getResultLatest75.map(item => {
                // tslint:disable-next-line:no-eval
                item['result'] = eval(item['result']);
                return item;
            }).reverse();
            const arrTempTotalPhienWrap = [];
            let j = 0;
            let i = 0;
            const arrTotalDot = [];
            listTotalPhien.forEach((item, idx) => {
                item['result'] = eval(item['result']);
                const totalDot = item['result'][0] + item['result'][1] + item['result'][2];
                arrTotalDot.push(totalDot);
            });
            arrTotalDot.forEach(totalDot => {
                if (totalDot > 10) {
                    if (arrTempTotalPhienWrap[j] && arrTempTotalPhienWrap[j].length === 5) {
                        j += 1;
                    }
                    if (!arrTempTotalPhienWrap[j]) {
                        arrTempTotalPhienWrap[j] = [];
                        i = j + 1;
                    }
                    arrTempTotalPhienWrap[j].push(totalDot);
                } else {
                    if (arrTempTotalPhienWrap[i] && arrTempTotalPhienWrap[i].length === 5) {
                        i += 1;
                    }
                    if (!arrTempTotalPhienWrap[i]) {
                        arrTempTotalPhienWrap[i] = [];
                        j = i + 1;
                    }
                    arrTempTotalPhienWrap[i].push(totalDot);
                }
            });
            const arrTopTotal = arrTempTotalPhienWrap.slice(arrTempTotalPhienWrap.length - 15, arrTempTotalPhienWrap.length);
            let htmlTotalNumDot = '';
            this.totalNumTai = this.totalNumXiu = 0;
            arrTopTotal.forEach((item: Array<any>, idx) => {
                item.forEach((subItem, idxSub) => {
                    subItem > 10 ? this.totalNumTai += 1 : this.totalNumXiu += 1;
                    const wColItem = this.wChart / 15;
                    const hColItem = this.hChart / 5;
                    const topDot = idxSub * hColItem + 1;
                    const leftDot = (idx * wColItem) + 3;
                    htmlTotalNumDot += `<span class="dotP ${subItem > 10 ? 'dotTai' : 'dotXiu'}" style="top: ${topDot}px; left: ${leftDot}px">${subItem}</span>`;
                });
            });
            this.elWrapTotal.nativeElement.innerHTML = htmlTotalNumDot;
            // END render total num dot

            // START render dot
            let htmlDotNums = '';
            let nextCol = 0;
            this.totalDotTai = this.totalDotXiu = 0;
            arrTotalDot.forEach((item, idx) => {
                item > 10 ? this.totalDotTai += 1 : this.totalDotXiu += 1;
                const colVal = idx % 5;
                if (colVal === 0 && idx > 0) {
                    nextCol += 1;
                }
                const wColItem = this.wChart / 15;
                const hColItem = this.hChart / 5;
                const topDot = colVal * hColItem + 1;
                const leftDot = (nextCol * wColItem) + 3;
                htmlDotNums += `<span class="dotP ${item > 10 ? 'dotTai' : 'dotXiu'}" style="top: ${topDot}px; left: ${leftDot}px"></span>`;
            });
            this.elWrapTotalDice.nativeElement.innerHTML = htmlDotNums;
            // END render dot
        });

        platform.ready().then((readySource) => {
            this.detectScreenOrient();
        });
        this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
            () => {
                this.detectScreenOrient();
            }
        );
    }

    detectScreenOrient() {
        setTimeout(() => {
            const pH = this.platform.height();
            const hGame = 325;
            if (pH < hGame) {
                this.elLspTXCB.nativeElement.style.transform = `scale(${(pH / hGame)})`;
            } else {
                this.elLspTXCB.nativeElement.style.transform = `scale(1)`;
            }
        }, 100);
    }

    ngOnInit() {}

    ngOnDestroy(): void {
        this.subscriptionLSP.unsubscribe();
        this.subscriptionScreenOri.unsubscribe();
    }

    ionViewWillEnter() {}

    renderChartDot123(arrDot, colorLine, clsDot) {
        let htmlDot = '';
        const arrAnchorDot = [];
        arrDot.forEach((item, idx) => {
            const whDot = 12;
            const wColItem = this.wChart / 15;
            const hColItem = this.hChart / 5;
            const topDot = (6 - item) * hColItem - whDot / 2;
            const leftDot = (idx * wColItem) - whDot / 2;
            arrAnchorDot.push({x: leftDot, y: topDot});
            htmlDot += `<span class="dot123 ${clsDot}" style="top: ${topDot}px; left: ${leftDot}px"></span>`;
        });
        arrAnchorDot.forEach((item, idx) => {
            if (idx + 1 < arrAnchorDot.length) {
                const nextItem = arrAnchorDot[idx + 1];
                htmlDot += `<svg><line x1="${item.x + (12 / 2)}" y1="${item.y + (12 / 2)}" x2="${nextItem.x + (12 / 2)}" y2="${nextItem.y + (12 / 2)}" style="stroke:${colorLine};stroke-width:1" /></svg>`;
            }
        });
        return htmlDot;
    }

    async closeModal() {
        await this.modalCtr.dismiss();
    }

    toggleDiceChart(event, numDice) {
        event.preventDefault();
        if (numDice === 1) {
            this.isHideDice1 = !this.isHideDice1;
            this.btnxnDisa1 = this.isHideDice1 ? '_kochon' : '';
        } else if (numDice === 2) {
            this.isHideDice2 = !this.isHideDice2;
            this.btnxnDisa2 = this.isHideDice2 ? '_kochon' : '';
        } else if (numDice === 3) {
            this.isHideDice3 = !this.isHideDice3;
            this.btnxnDisa3 = this.isHideDice3 ? '_kochon' : '';
        }
    }

    toggleBlock(event) {
        event.preventDefault();
        this.isHideChartPhien = !this.isHideChartPhien;
        this.isHideTotalPhien = !this.isHideTotalPhien;
    }
}
